<template>
  <main id="form-page">
    <div id="nongkrong-bareng-barry-page">
      <div v-if="showSubmitloaderForm" class="loader-wrapper" :class="{ success: isSuccess }">
        <div class="loader-spinner">
          <div class="expanding-ring ring-1" v-if="isSuccess"></div>
          <div class="expanding-ring ring-2" v-if="isSuccess"></div>

          <div class="loader-core"></div>
        </div>
      </div>
      <div v-else class="container-nongkrong py-4">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <form
                method="POST"
                @submit.prevent="onSubmit"
                @keydown="form.errors.clear($event.target.name)"
                enctype="multipart/form-data"
            >
              <div class="form-wrapper">
                <div class="banner-jalur-tawa">
                  <img src="https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/banner-jalur-tawa-touring-24062025-040303.png" alt="Banner Nongkrong Bareng Barry Touring">
                </div>

                <!-- Data Diri BradSis -->
                <div class="card">
                  <div class="card-header">
                    <h3 class="title-header-card">Data Diri BradSis</h3>
                    <img :src="base_url + '/images/icon-helmet.png'" alt="Icon Helmet">
                  </div>
                  <div class="card-body">
                      <div class="form-group row" :id="form.errors.has('name') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="name">Nama</label>
                          <input
                            v-model="form.name"
                            @input="lettersOnly($event)"
                            type="text"
                            class="formInput form-register"
                            id="name"
                            aria-describedby="name"
                            placeholder="Masukkan Nama"
                            autocomplete="off"
                          />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('name')"
                        v-text="form.errors.get('name')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('phone') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="phone">No. Telepon</label>
                          <input
                              @click.right.prevent
                              @copy.prevent
                              @paste.prevent
                              v-model="form.phone"
                              @input="phoneNumbersOnly($event)"
                              type="tel"
                              class="formInput form-register"
                              id="phone"
                              aria-describedby="phone"
                              placeholder="08XXXXXXXX"
                              autocomplete="off"
                          />
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('phone')"
                          v-text="form.errors.get('phone')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('instagram') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="instagram">Akun Instagram</label>
                          <input
                            v-model="form.instagram"
                            @input="instagramValidation($event)"
                            type="text"
                            class="formInput form-register"
                            id="instagram"
                            aria-describedby="instagram"
                            placeholder="Masukkan Instagram"
                            autocomplete="off"
                          />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('instagram')"
                        v-text="form.errors.get('instagram')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('province') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="province">Provinsi</label>
                          <div class="custom-dropdown-select">
                              <v-select
                                  id="province"
                                  v-model="province"
                                  @input="changeProvince($event)"
                                  :options="provinces"
                                  class="my-custom-vselect"
                                  label="name"
                                  placeholder="Pilih Provinsi"
                              >
                              </v-select>
                          </div>
                          <div class="dropdown-label">
                            <!-- <span class="title-dropdown-label">Label</span> -->
                            <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                          </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('province')"
                          v-text="form.errors.get('province')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('city') ? 'error-field' : false">
                        <div class="column-form" :style="cities.length == 0 ? 'opacity: 0.3;cursor: not-allowed;' : ''">
                          <label class="label-form" for="city">Kota</label>
                            <div class="custom-dropdown-select">
                              <v-select
                                  id="city"
                                  v-model="city"
                                  @input="changeCity($event)"
                                  :options="cities"
                                  :disabled="cities.length == 0"
                                  class="my-custom-vselect"
                                  label="name"
                                  placeholder="Pilih Kota"
                              >
                              </v-select>
                            </div>
                            <div class="dropdown-label">
                              <!-- <span class="title-dropdown-label">Label</span> -->
                              <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                            </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('city')"
                          v-text="form.errors.get('city')"
                        >
                        </span>
                      </div>
                  </div>
                </div>

                <!-- Motor yang Dipakai Sekarang -->
                <div class="card">
                  <div class="card-header">
                    <h3 class="title-header-card">Motor yang Dipakai Sekarang</h3>
                  </div>
                  <div class="card-body">
                      <div class="form-group row" :id="form.errors.has('brand_motor') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="brand_motor">Brand</label>
                          <div class="custom-dropdown-select">
                              <v-select
                                  id="brand_motor"
                                  class="my-custom-vselect"
                                  :options="brand_motors"
                                  label="title"
                                  placeholder="Pilih Brand Motor"
                                  @input="changeBrandMotor($event)"
                                  v-model="brand_motor"
                              >
                              </v-select>
                          </div>
                          <div class="dropdown-label">
                            <!-- <span class="title-dropdown-label">Label</span> -->
                            <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                          </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('brand_motor')"
                          v-text="form.errors.get('brand_motor')"
                        >
                        </span>
                      </div>


                      <div class="form-group row" :id="form.errors.has('product_category') ? 'error-field' : false">
                        <div class="column-form" :style="productCategoryItems.length == 0 ? 'opacity: 0.3;cursor: not-allowed;' : ''">
                          <label class="label-form" for="product_category">Tipe</label>
                            <div class="custom-dropdown-select">
                              <v-select
                                  id="product_category"
                                  v-model="product_category"
                                  @input="changeProductCategory($event)"
                                  :options="productCategoryItems"
                                  :disabled="productCategoryItems.length == 0"
                                  class="my-custom-vselect"
                                  label="title"
                                  placeholder="Pilih Tipe Motor"
                              >
                              </v-select>
                            </div>
                            <div class="dropdown-label">
                              <!-- <span class="title-dropdown-label">Label</span> -->
                              <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                            </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('product_category')"
                          v-text="form.errors.get('product_category')"
                        >
                        </span>
                      </div>
                      <!-- <div v-else class="form-group row" :id="form.errors.has('product_category') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="product_category">Tipe Motor</label>
                          <input
                            @input="tipeMotorValidation($event)"
                            type="text"
                            class="formInput form-register"
                            id="product_category"
                            aria-describedby="product_category"
                            v-model="tipeBrandLain"
                            placeholder="Masukkan Tipe Motor"
                            autocomplete="off"
                          />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('product_category')"
                        v-text="form.errors.get('product_category')"
                        >
                        </span>
                      </div> -->

                      <div v-if="tipeBrand != 'Other' && tipeProductCategory != 'Other'" class="form-group row" :id="form.errors.has('product') ? 'error-field' : false">
                        <div class="column-form" :style="productItems.length == 0 ? 'opacity: 0.3;cursor: not-allowed;' : ''">
                          <label class="label-form" for="product">Nama Motor</label>
                            <div class="custom-dropdown-select">
                              <v-select
                                  id="product"
                                  v-model="product"
                                  @input="changeProduct($event)"
                                  :options="productItems"
                                  :disabled="productItems.length == 0"
                                  class="my-custom-vselect"
                                  label="title"
                                  placeholder="Pilih Varian Motor"
                              >
                              </v-select>
                            </div>
                            <div class="dropdown-label">
                              <!-- <span class="title-dropdown-label">Label</span> -->
                              <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                            </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('product')"
                          v-text="form.errors.get('product')"
                        >
                        </span>
                      </div>
                      <div v-else class="form-group row" :id="form.errors.has('product') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="product">Nama Motor</label>
                          <input
                            @input="namaMotorValidation($event)"
                            type="text"
                            class="formInput form-register"
                            id="product"
                            aria-describedby="product"
                            v-model="tipeProductCategoryLain"
                            placeholder="Masukkan Nama Motor"
                            autocomplete="off"
                          />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('product')"
                        v-text="form.errors.get('product')"
                        >
                        </span>
                      </div>

                      <div class="form-group row" :id="form.errors.has('year') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="year">Tahun Produksi</label>
                            <div class="custom-dropdown-select">
                              <v-select
                                  class="my-custom-vselect"
                                  :options="years"
                                  label="name"
                                  placeholder="Pilih Tahun Produksi"
                                  @input="changeYear($event)"
                                  v-model="year"
                              >
                              </v-select>
                            </div>
                            <div class="dropdown-label">
                              <!-- <span class="title-dropdown-label">Label</span> -->
                              <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                            </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('year')"
                          v-text="form.errors.get('year')"
                        >
                        </span>
                      </div>
                  </div>
                </div>

                <!-- Komunitas BradSis -->
                <div class="card">
                  <div class="card-header">
                    <h3 class="title-header-card">Komunitas BradSis</h3>
                  </div>
                  <div class="card-body">
                      <div class="form-group row" :id="form.errors.has('community_name') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="community_name">Nama Komunitas</label>
                          <input
                            @input="communityNameValidation($event)"
                            type="text"
                            class="formInput form-register"
                            id="community_name"
                            aria-describedby="community_name"
                            v-model="form.community_name"
                            placeholder="Masukkan Nama Komunitas"
                            autocomplete="off"
                          />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('community_name')"
                        v-text="form.errors.get('community_name')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('community_joined_year') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="community_joined_year">Tahun Bergabung Komunitas</label>
                          <input
                            @input="yearValidation($event)"
                            v-model="form.community_joined_year"
                            type="text"
                            inputmode="numeric"
                            class="formInput form-register"
                            id="community_joined_year"
                            aria-describedby="community_joined_year"
                            placeholder="Masukkan Tahun Bergabung"
                            autocomplete="off"
                          />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('community_joined_year')"
                        v-text="form.errors.get('community_joined_year')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('has_joined_touring') ? 'error-field' : false">
                        <div class="column-form">
                          <label class="label-form" for="has_joined_touring">Pernah Ikut Touring</label>
                            <div class="custom-dropdown-select">
                              <v-select
                                  id="has_joined_touring"
                                  class="my-custom-vselect"
                                  :options="tourings"
                                  label="name"
                                  placeholder="Pilih Jawaban"
                                  @input="changeOption($event)"
                                  v-model="has_joined_touring"
                              >
                              </v-select>
                            </div>
                            <div class="dropdown-label">
                              <!-- <span class="title-dropdown-label">Label</span> -->
                              <img class="icon-dropdown-label" :src="base_url + '/images/icon-arrow-dropdown.svg'" alt="Icon Arrow Dropdown">
                            </div>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('has_joined_touring')"
                          v-text="form.errors.get('has_joined_touring')"
                        >
                        </span>
                      </div>
                  </div>
                </div>

                <!-- Konfirmasi & Janji BradSis -->
                <div class="card">
                  <div class="card-header-confirmation">
                    <h3 class="title-header-card">Konfirmasi & Janji BradSis</h3>
                    <p>Dengan mengisi form ini, saya menyatakan:</p>
                  </div>
                  <div class="card-body">
                      <div class="form-group row" :id="form.errors.has('agree_tnc') ? 'error-field' : false">
                        <div class="col">
                          <input type="checkbox" class="form-check-input" id="agree_tnc" v-model="agreeTnc" @change="changeAgreeTnc($event)" />
                          <label class="form-check-label" for="agree_tnc">
                            <div class="editor-output">
                              <p>Saya sudah membaca & menyetujui <strong><a href="#" @click.prevent="showTerm">Ketentuan & Peraturan</a></strong> dalam acara ini</p>
                            </div>
                          </label>
                        </div>
                        <span
                            class="help-block"
                            v-if="form.errors.has('agree_tnc')"
                            v-text="form.errors.get('agree_tnc')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('safety_agreed') ? 'error-field' : false">
                        <div class="col">
                          <input type="checkbox" class="form-check-input" id="safety_agreed" v-model="safetyAgreed" @change="changeSafetyAgreed($event)" />
                          <label class="form-check-label" for="safety_agreed">
                            <div class="editor-output">
                              <p>Saya siap membawa helm yang sudah sesuai standar SNI, memakai jaket, celana panjang, dan sepatu saat touring nanti</p>
                            </div>
                          </label>
                        </div>
                        <span
                            class="help-block"
                            v-if="form.errors.has('safety_agreed')"
                            v-text="form.errors.get('safety_agreed')"
                        >
                        </span>
                      </div>
                      <div class="form-group row" :id="form.errors.has('agree') ? 'error-field' : false">
                        <div class="col">
                          <input type="checkbox" class="form-check-input" id="agree" v-model="agree" @change="changeAgree($event)" />
                          <label class="form-check-label" for="agree">
                            <div class="editor-output" v-html="pagePrivacy.summary"></div>
                          </label>
                        </div>
                        <span
                            class="help-block"
                            v-if="form.errors.has('agree')"
                            v-text="form.errors.get('agree')"
                        >
                        </span>
                      </div>
                  </div>
                </div>
                <div class="row justify-content-center btn-submit">
                  <div v-if="showSubmitloaderForm" class="loading loading-double"></div>
                  <button v-else  type="button" @click="onSubmit" class="btn mx-2 btn-red">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <popup-jalur-tawa-tnc ref="popupTnc"></popup-jalur-tawa-tnc>
    </div>
  </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
import PopupJalurTawaTnc from "../../widget/PopupJalurTawaTnc.vue";

export default {
  components: {
    "v-select": vSelect,
    "popup-jalur-tawa-tnc": PopupJalurTawaTnc
  },
  data() {
    return {
      base_url:base_url,
      app_url: app_url,
      api_url: api_url,
      main_site_url: main_site_url,
      date: new Date(),
      showloader: false,
      mobile:false,
      slug: this.$route.params.slug,
      showSubmitloaderForm: false,
      city: null,
      province: null,
      product_category:null,
      product: null,
      brand_motors: [],
      brand_motor: null,
      provinces: [],
      cities: [],
      products: [],
      productItems: [],
      years: [
        '2000 - 2005',
        '2006 - 2010',
        '2011 - 2015',
        '2016 - 2020',
        '2021 - 2025'
      ],
      productCategories: [],
      productCategoryItems: [],
      productCategoriesWithOthers: [],
      selectcity:true,
      tipeBrand:'',
      tipeBrandLain:'',
      tipeProductCategory: '',
      tipeProductCategoryLain:'',
      imageUploaded: [],
      form: new Form({
        type: 'nongkrong-bareng-barry-touring',
        name: "",
        phone: "",
        instagram:'',
        province: "",
        city: "",
        brand_motor: "",
        product_category: '',
        product: '',
        year:'',
        community_name: '',
        community_joined_year: '',
        has_joined_touring: '',
        // food_beverage_preferences: '',
        agree:'',
        agree_tnc: '',
        safety_agreed: '',
        referral:'',
      }),
      year: null,
      motorVariant: '',
      tourings: [ 'Ya', 'Tidak' ],
      has_joined_touring: null,
      agree: false,
      agreeTnc: false,
      safetyAgreed: false,
      pagePrivacy: {},
      isSuccess: false,
      // food_beverages: [
      //   'Ayam Goreng',
      //   'Nasi Goreng',
      //   'Mie Goreng',
      //   'Es Teh Manis',
      //   'Es Kopi',
      //   'Es Jeruk',
      //   'Es Kelapa',
      // ],
      // food_beverage_preferences: null,
    };
  },
  watch: {
    tipeBrandLain(data) {
      if (data.length) {
        this.form.product_category = JSON.stringify({id : this.brand_motor, title : data});
      } else {
        this.form.product_category = '';
      }
    },
    tipeProductCategoryLain(data) {
      if (data.length) {
        this.form.product = JSON.stringify({id : this.brand_motor == 'Other' ? 'Other' : this.product_category, title : data});
      } else {
        this.form.product = '';
      }
    }
  },
  created() {
    this.mobile = isMobile;
    this.fetchProvince();
    this.fetchBrandMotors();
    this.fetchProductCategories();
    this.fetchProducts();
    this.fetchPagePrivacy();
    this.form.referral = sessionStorage.getItem('session_referral') ?? '';
  },
  methods: {
    onSubmit() {
      this.isSuccess = false;
      this.showSubmitloaderForm = true;

      this.form
        .post(api_url + "/nongkrong-bareng-barry-touring")
        .then((response) => {
          // this.showSubmitloaderForm = false;
          this.isSuccess = true;
          if (response.success) {
            localStorage.setItem('nongkrong-bareng-barry-touring',JSON.stringify(response))
            let track = {
              'event': 'formSubmissionEvent',
              'formId': response.data.form_id,
              'title': 'Honda Community Event',
              'subtopic': 'Jalur Tawa-Nongkrong Bareng Barry Williem',
              'selectedProvince': response.data.province !== undefined && response.data.province !== null ? response.data.province.name : null,
              'selectedCity': response.data.city !== undefined && response.data.city !== null ? response.data.city.name : null,
              'motorCategory': response.data.product_category !== undefined && response.data.product_category !== null ? response.data.product_category.title : null,
              'motorVariant': response.data.product !== undefined && response.data.product !== null ? response.data.product.title : null,
              'manufactureYear': response.data.year,
              'communityName': response.data.community_name,
              'option': `IG:${response.data.instagram}|MotorBrand:${response.data.brand_motor}|JoinCommunity:${response.data.community_joined_year}|Touring:${response.data.has_joined_touring}`,
            };
            dataLayer.push(track);

            setTimeout(() => {
              this.$router.push('/community/touring/jalur-tawa/thank-you')
            }, 500);
          }
        })
        .catch((response) => {
          this.showSubmitloaderForm = false;

          setTimeout(() => {
            const el = document.querySelector('#error-field')
            if (el) {
              const elementTop = el.getBoundingClientRect().top + window.pageYOffset
              const offset = elementTop - (window.innerHeight / 2) + (el.offsetHeight / 2)
              window.scrollTo({
                top: offset,
                behavior: 'smooth'
              })
            }
          }, 100);
        });
    },
    showTerm() {
      // const data = this.pageContent
      this.$refs.popupTnc.show()
    },
    phoneNumbersOnly(evt) {
      const input = evt.target.value;
      evt.target.value = input.replace(/[^0-9]/g, "");

      if (evt.target.value.length > 14) {
          this.form.phone = evt.target.value.slice(0, 14);
      } else {
          this.form.phone = evt.target.value;
      }
    },
    async fetchPagePrivacy() {
        try {
            const response = await axios.get(
                `${api_mainsite_url}/page/type/persetujuan-privasi`
            );

            this.pagePrivacy = response.data;
        } catch (error) {
            console.log(error);
        }
    },
    async fetchYear() {
        const response = await axios.get(`${api_url}/setting`, {params: {type: 'yearproduct'}})
        this.years = response.data;
    },
    fetchProvince() {
      (this.showloader = true),
        axios.get(api_url + "/static/province").then((response) => {
          this.provinces = response.data.data.provincy;
          this.showloader = false;
        });
    },
    fetchCity(province) {
     this.selectcity = false;
      axios.get(api_url + '/static/city/'+province).then((response) => {
        this.cities = response.data.data.city;
        this.selectcity = true;
      });
    },
    fetchProducts() {
      axios
        .get(`${api_url}/static/motor-list`)
        .then((response) => {
          this.products = response.data;
        })
    },
    fetchBrandMotors() {
      axios.get(api_url + "/static/brand-list").then((response) => {
        this.brand_motors = response.data;
      });
    },
    fetchProductCategories() {
      axios.get(api_url + "/static/motor-category-list").then((response) => {
        this.productCategories = response.data;
      });
    },
    changeProvince(event) {
      this.form.city = '';
      this.cities = [];
      this.city = null;

      if(event){
        this.form.province = JSON.stringify({
          id: event._id,
          name: event.name,
          slug: event.slug,
          code: event.code,
        });

        this.fetchCity(event._id);
      } else {
        this.form.province = '';
        this.province = null;
      }
    },
    changeCity(event) {
      if (event) {
        this.form.city = JSON.stringify({
          id: event._id,
          name: event.name,
          slug: event.slug,
        });
      } else {
        this.form.city = '';
        this.city = null;
      }
    },
    changeBrandMotor(event) {
      this.productCategoryItems = [];
      this.form.product_category = '';
      this.product_category = null;
      this.tipeBrandLain = '';
      this.tipeProductCategory = '';
      this.tipeProductCategoryLain = '';

      this.form.product = '';
      this.product = null;

      this.productItems = [];

      this.form.year = '';
      this.year = null;

      if (event) {
        this.form.brand_motor = event;
        this.brand_motor = event;

        this.tipeBrand = event;

        // if (this.tipeBrand != 'Other'){
          this.productCategoryItems = this.productCategories.filter(item => item.brand == event);
        // }
      } else {
        this.tipeBrand = '';
        this.form.brand_motor = '';
        this.brand_motor = null;
      }
    },
    changeProductCategory(event) {
      this.productItems = [];
      this.product = null;
      this.form.product = '';

      this.tipeProductCategoryLain = '';
      
      this.year = null;
      this.form.year = '';

      if (event) {
        this.tipeProductCategory = event.title;
        this.form.product_category = JSON.stringify({id : event.title, title : event.title, brand : event.brand});

        if (this.tipeProductCategory != 'Other'){
          this.productItems = this.products.filter(item => item.brand == event.brand && item.category == event.title);
        }
      } else {
        this.tipeProductCategory = '';
        this.form.product_category = '';
        this.product_category = null;
      }
    },
    changeProduct(event) {
      this.form.year = '';
      this.year = null;
      this.form.other_variant = '';

      if (event) {
        this.form.product = JSON.stringify({id : event.title, title : event.title, brand : event.brand, category : event.category});
      } else {
        this.form.product = '';
      }
    },
    changeAgreeEvent(event) {
      if (event) {
        this.form.agree_event = event.slug;
      } else {
        this.form.agree_event = '';
        this.kopdar = null;
      }
    },
    changeAddress(event) {
      if(event){
        this.form.address = event.name;
      } else {
        this.form.address = '';
        this.address = null;
      }
    },
    changeOption(event) {
      if (event) {
        this.has_joined_touring = event;
        this.form.has_joined_touring = event;
      } else {
        this.form.has_joined_touring = '';
        this.has_joined_touring = null;
      }
    },
    changeFoodBeverage(event) {
      if (event) {
        this.form.food_beverage_preferences = event;
        this.food_beverage_preferences = event;
      } else {
        this.form.food_beverage_preferences = '';
        this.food_beverage_preferences = null;
      }
    },
    replaceString(str) {
      str.replace(/\./g, " ");
      str.replace(" ", "_");
      return str;
    },
    changeYear(event) {
      if (event) {
        this.form.year = event;
      } else {
        this.form.year = '';
        this.year = null;
      }
    },
    changeMotorVariant(event) {
      if (event) {
        this.form.motor_variant = event;
      } else {
        this.form.motor_variant = "";
        this.motor_variant = null;
      }
    },
    changePreferredProduct(event) {
      if (event) {
        this.form.preferred_product = event;
      } else {
        this.form.preferred_product = "";
        this.preferred_product = null;
      }
    },
    changeAgree(event) {
      if (event.target.checked) {
        this.form.agree = true;
        this.agree = true;
      } else {
        this.form.agree = '';
        this.agree = false;
      }
    },
    changeAgreeTnc(event) {
      if (event.target.checked) {
        this.form.agree_tnc = true;
        this.agreeTnc = true;
        this.showTerm();
      } else {
        this.form.agree_tnc = '';
        this.agreeTnc = false;
      }
    },
    changeSafetyAgreed(event) {
      if (event.target.checked) {
        this.form.safety_agreed = true;
        this.safetyAgreed = true;
      } else {
        this.form.safety_agreed = '';
        this.safetyAgreed = false;
      }
    },
    getParam(param) {
      var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i=0;i<url.length;i++) {
          var params = url[i].split("=");
          if(params[0] == param)
            return params[1];
      }
      return false;
    },
    insertParam(key, value) {
        var uri = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
          return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
          return uri + separator + key + "=" + value;
        }
    },
    removeFile(){
      this.form.file = '';
      this.imageUploaded = [];
    },
    handleLowercaseInput() {
      if (this.form.motor_variant.trim() === "") {
        this.form.motor_variant = "";
      } else {
        this.form.motor_variant = this.form.motor_variant.replace(/[^a-zA-Z\s]/g, "").toLowerCase();
      }
    },
    handleNumericInput() {
      this.form.cubic_centimeter = this.form.cubic_centimeter.replace(/[^0-9]/g, '');

      // Limit the input to a maximum of 5 digits
      if (this.form.cubic_centimeter.length > 5) {
        this.form.cubic_centimeter = this.form.cubic_centimeter.slice(0, 5);
      }
    },
    handleAgeLength() {
      if (this.form.age.length > 2) {
        this.form.age = this.form.age.slice(0, 2);
      }
    },
    lettersOnly(evt) {
        const input = evt.target.value;
        evt.target.value = input.replace(/[^a-zA-Z\s]/g, "");

        if (evt.target.value.length > 30) {
            this.form.name = evt.target.value.slice(0, 30);
        } else {
            this.form.name = evt.target.value;
        }
    },
    alphanumericOnly(evt) {
        const input = evt.target.value;
        evt.target.value = input.replace(/[^a-zA-Z0-9\s]/g, "");

        if (evt.target.value.length > 30) {
            this.form.community_duration = evt.target.value.slice(0, 30);
        } else {
            this.form.community_duration = evt.target.value;
        }
    },
    communityNameValidation(event) {
      const value = event.target.value;
      const cleaned = value.replace(/[^\p{L}\p{N}.,'"()\-&\/_\s]/gu, '').slice(0, 100);
      this.form.community_name = cleaned;
    },
    yearValidation(event) {
      const input = event.target.value;
      const cleaned = input.replace(/[^0-9]/g, "").slice(0, 4);
      this.form.community_joined_year = cleaned
    },
    instagramValidation(event) {
      const value = event.target.value;
      const cleaned = value.replace(/[^a-zA-Z0-9._@\s]/g, '').slice(0, 70);
      this.form.instagram = cleaned;
    },
    tipeMotorValidation(event) {
      const value = event.target.value;
      const cleaned = value.replace(/[^a-zA-Z0-9\s]/g, '').slice(0, 30);
      this.tipeBrandLain = cleaned;
    },
    namaMotorValidation(event) {
      const value = event.target.value;
      const cleaned = value.replace(/[^a-zA-Z0-9\s]/g, '').slice(0, 100);
      this.tipeProductCategoryLain = cleaned;
    }
  },
};
</script>
<style lang="scss">
  #nongkrong-bareng-barry-page {
    background-image: url('https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/background-nongkrong-bareng-barry-13062025-020636.webp');
    background-size: cover;
    background-position: center;
    // background-repeat: no-repeat;
    min-height: 100dvh;

    .vue-input-tag-wrapper .input-tag {
      background: #282828;
      border-radius: 10px;
      color: #FFFFFF;
      align-self: center;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding: 5px 1rem 5px 1rem !important;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      .vue-input-tag-wrapper .input-tag {
        background: #E61B33;
        line-height: 22px;
        height: 25px;
        padding: 0px 1rem 0px 1rem !important;
      }
    }
  }
  .my-custom-vselect .vs__dropdown-toggle {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }
  // .vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__search {
  //   background-color: #eaeaea !important;
  // }
  .my-custom-vselect .vs__selected-options {
    font-size: 16px !important;
  }
  .my-custom-vselect .vs__selected {
    font-size: 16px !important;
  }
  .my-custom-vselect .vs__actions {
    display: none !important;
  }
  .my-custom-vselect .vs__search::placeholder {
    color: #b4b4b4 !important;
  }
  .editor-output p {
    color: #A71D28;
    margin: 0;
  }

  @media (max-width: 576px) {
    .my-custom-vselect .vs__selected-options {
      font-size: 14px !important;
    }
    .my-custom-vselect .vs__selected {
      font-size: 14px !important;
    }
  }
</style>
<style scoped lang="scss">
.container-nongkrong {
  max-width: 600px;
  margin: 0 auto;
}
.btn-red {
  background-color: red;
  color: white;
}
.loader-wrapper {
  position: fixed;
  inset: 0;
  background: transparent; // tetap transparan
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  &.success {
    .loader-spinner::before {
      animation: none; // stop putaran
      opacity: 0; // sembunyikan spinner
    }

    .expanding-ring {
      animation: expandRing 6s ease-out forwards;
    }

    .ring-2 {
      animation-delay: 0.1s;
    }

    .loader-core {
      animation: scaleUpLogo 1s ease-out forwards;
    }
  }
}

.loader-spinner {
  width: 200px;
  height: 200px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: "";
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    padding: 115px;
    background: conic-gradient(#E41A2B, white, #E41A2B);
    -webkit-mask:
      radial-gradient(farthest-side, transparent calc(100% - 20px), black 20%);
    mask:
      radial-gradient(farthest-side, transparent calc(100% - 20px), black 20%);
    animation: spin 0.2s linear infinite;
    z-index: 1;
  }
}

.loader-core {
  width: 200px;
  height: 200px;
  background: transparent;
  background-image: url('https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/logo-jalur-tawa-1-17062025-054246.webp');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  z-index: 2;
}

.expanding-ring {
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  z-index: 0;
  transform: scale(1);
  opacity: 1;
  animation: expandRing 6s ease-out forwards;
  box-shadow:
    0 0 0 15px #E41A2B,
    0 0 0 30px rgba(255, 255, 255, 0.6),
    0 0 0 45px rgba(228, 26, 43, 0.3),
    0 0 0 60px rgba(255, 255, 255, 0.15);
}

.ring-2 {
  animation-delay: 0.1s;
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes expandRing {
  0% {
    transform: scale(1);
    opacity: 1;
    box-shadow:
      0 0 0 15px #E41A2B,
      0 0 0 30px rgba(255, 255, 255, 0.6),
      0 0 0 45px rgba(228, 26, 43, 0.3),
      0 0 0 60px rgba(255, 255, 255, 0.15);
  }

  100% {
    transform: scale(40);
    opacity: 0;
    box-shadow:
      0 0 0 3000px rgba(228, 26, 43, 0.08),
      0 0 0 4000px rgba(255, 255, 255, 0.03),
      0 0 0 5000px rgba(228, 26, 43, 0.02),
      0 0 0 6000px rgba(255, 255, 255, 0.01);
  }
}

@keyframes expandRingMobile {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(20);
    opacity: 0;
    box-shadow:
      0 0 0 1000px rgba(228, 26, 43, 0.08),
      0 0 0 1500px rgba(255, 255, 255, 0.03),
      0 0 0 2000px rgba(228, 26, 43, 0.02),
      0 0 0 2500px rgba(255, 255, 255, 0.01);
  }
}

@keyframes scaleUpLogo {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  30% {
    transform: scale(1.05);
    opacity: 1;
  }
  60% {
    transform: scale(0.90);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 576px) {
  .expanding-ring {
    width: 120px;
    height: 120px;
    box-shadow:
      0 0 0 10px #E41A2B,
      0 0 0 20px rgba(255, 255, 255, 0.6),
      0 0 0 30px rgba(228, 26, 43, 0.3),
      0 0 0 40px rgba(255, 255, 255, 0.15);
    animation: expandRingMobile 6s ease-out forwards;
  }

  .ring-2 {
    // animation: expandRingMobile 0.1s ease-out forwards;
    animation-delay: 0.1s;
  }
}
#nongkrong-bareng-barry-page {
  font-family: Manrope;
  .card {
    margin: 2rem 15px 0 15px;
    background: #ffffff;
    border: none;
    border-radius: 10px;
    padding: 20px 30px;
    box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.45);
    -webkit-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.45);
    -moz-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.45);
    /* font-family: Inter; */

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 28px;
      height: 28px;
      background: white;
      border-top-left-radius: 4px;
      transform: translate(25%, -30%) rotate(45deg);
      z-index: 1;
    }
  }
  .card-header {
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    border: none;
    background-color: #fff;
  }
  .card-header-confirmation {
    // margin-bottom: 1rem;
    padding: 0;
    border: none;
    background-color: #fff;

    p {
      color: #A71D28;
    }
  }
  .card-body {
    padding: 0 1.25rem;
  }
  .title-header-card {
    color: #E41A2B;
    font-weight: bold;
    font-size: 1.5rem;
  }
  .column-form {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
  }
  label {
    margin: 0;
  }
  .label-form {
    width: 50%;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #A71D28;
  }
  .form-register {
    border: none;
    width: 100%;
    text-align: right;
    color: #000;
    font-size: 16px;

    &::placeholder {
      color: #b4b4b4;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .custom-dropdown-select {
    width: 100%;
    margin-right: 20px;
  }
  .dropdown-label {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title-dropdown-label {
    color: #D21926;
    font-weight: bold;
  }
  // .form-check-label {
  //   p {
  //     color: #A71D28 !important;
  //   }
  // }
  .icon-dropdown-label {
    margin-left: 5px;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(/images/arrow-select.png) no-repeat right white;
    background-position-x: 98.5%;
  }
  .btn-submit {
    margin: 40px 0;
  }
  .btn {
    width: 161px;
  }
  .btn-red {
    background: #e61b33;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  .fa {
    cursor: pointer;
  }
  @media (max-width: 768px) {
    select {
      background-position-x: 95.5%;
    }
    // .label-form {
    //   // font-weight: 300;
    // }
    .form-register {
      height: 40px;
    }
    .btn {
      width: 120px;
    }
  }
  @media (max-width: 576px) {
      .card {
        padding: 20px 15px;
      }
    
      // .card-header {
      //   img {
      //     width: 20%;
      //   }
      // }
    
      .title-header-card {
        font-size: 1.2rem;
      }
    
      .label-form {
        font-size: 14px;
      }
    
      .form-register {
        font-size: 14px;
    
        &::placeholder {
          font-size: 14px;
        }
      }
  }
}
</style>
